import { InputAdornment, IconButton, Tooltip } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

export function InputValidationEndAdornment({
  isVerified,
  title
}: {
  isVerified: boolean
  title: string
}) {
  return (
    <InputAdornment position="end">
      <Tooltip title={title} arrow>
        <IconButton edge="end" tabIndex={-1}>
          {isVerified ? <CheckIcon color="success" /> : <ErrorOutlineIcon color="error" />}
        </IconButton>
      </Tooltip>
    </InputAdornment>
  )
}
